<div class="d-grid gap-3" style="grid-template-columns: 2fr 1fr">
  <div class="border rounded bg-white overflow-hidden">
    <table class="table">
      <tr *ngIf="dragulaGroup?.drake?.dragging">
        <td>
          <!-- First Placeholder -->
          <div
            [dragula]="draggableSignerItemsGroupKey"
            [dragulaModel]="[]"
            [attr.data-role-order]="0"
            class="signer-item-group group-placeholder"
          >
            <div i18n>Drop here to create a new order</div>
          </div>
        </td>
      </tr>
      <tr
        *ngFor="
          let items of groupedSignerItemCtrls;
          let groupIndex = index;
          let groupCount = count;
          let last = last;
          let first = first
        "
        [class.multiple]="items.length > 1"
      >
        <td>
          <div
            [dragula]="draggableSignerItemsGroupKey"
            [dragulaModel]="items"
            [attr.data-role-order]="groupIndex + 1"
            class="signer-item-group"
            [class.multiple]="items.length > 1"
          >
            <ng-container *ngFor="let form of items; let index = index; let count = count">
              <div class="signer-item-wrapper" [class.flat]="count < 2">
                <div class="sort-actions-wrapper text-xxl" *ngIf="sortable">
                  <span
                    class="fas fa-angle-up move-up-icon"
                    (click)="onMoveUp(form, groupIndex + 1)"
                    i18n-matTooltip
                    matTooltip="Click here to move the signer earlier in the signing order."
                    matTooltipPosition="right"
                  ></span>
                  <div class="cs-icon cs-icon-drag-handler" [ngClass]="draggableSignerItemHandler"></div>
                  <span
                    class="fas fa-angle-down move-down-icon"
                    (click)="onMoveDown(form, groupIndex + 1)"
                    i18n-matTooltip
                    matTooltip="Click here to move the signer later in the signing order."
                    matTooltipPosition="right"
                  ></span>
                </div>
                <div class="signer-item-form d-flex align-items-center">
                  <div class="flex-1">
                    <ng-template
                      [ngTemplateOutlet]="formDirective.templateRef"
                      [ngTemplateOutletContext]="{ form: form, index: groupIndex + index }"
                    ></ng-template>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </td>
      </tr>
      <tr *ngIf="dragulaGroup?.drake?.dragging">
        <td>
          <!-- Last Placeholder -->
          <div
            [dragula]="draggableSignerItemsGroupKey"
            [dragulaModel]="[]"
            [attr.data-role-order]="groupedSignerItemCtrls?.length + 1"
            class="signer-item-group group-placeholder"
          >
            <div i18n>Drop here to create a new order</div>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="border rounded bg-white">
    <table class="table">
      <tr
        *ngFor="
          let items of groupedSignerItemCtrls;
          let groupIndex = index;
          let groupCount = count;
          let last = last;
          let first = first
        "
        [class.multiple]="items.length > 1"
      >
        <td>
          <app-signing-diagram
            [order]="groupIndex + 1"
            [labelKey]="labelKey"
            [items]="getItemsValue | call : items : isSignerDataChanged"
            [last]="last"
            [first]="first"
            [total]="groupCount"
          ></app-signing-diagram>
        </td>
      </tr>
    </table>
  </div>
</div>
